<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="username">
        <el-input v-model="queryParams.username" placeholder="登陆昵称"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="type">
        <el-select v-model="queryParams.type" filterable placeholder="日志类型" @change="search" clearable >
          <el-option v-for="item in journal" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="remark" >
        <el-input v-model="queryParams.remark" placeholder="备注内容"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="mode" >
        <el-input v-model="queryParams.mode" placeholder="操作方式"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="table" style="margin-top: 10px">
      <el-table :data="tableData" border>
        <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="username" label="登陆昵称" align="center"></el-table-column>
        <el-table-column prop="iccid" label="ICCID" align="center" width="185px"></el-table-column>
        <el-table-column prop="module" label="请求模块" align="center"></el-table-column>
        <el-table-column prop="mode" label="操作方式" align="center"></el-table-column>
        <el-table-column prop="type" label="日志类型" align="center">
            <template slot-scope="{row}">
              <span v-if="row.type =='1'">登陆日志</span>
              <span v-else-if="row.type =='2'">操作日志</span>
              <span v-else>备注日志</span>
            </template>
        </el-table-column>
        <el-table-column prop="flag" label="请求结果" align="center"></el-table-column>
        <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        <el-table-column prop="ip" label="IP地址" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { logIndex } from "@/api/api.js"; //事业部组
export default {
  data() {
    return{
      queryParams:{
        username:undefined,
        iccid:undefined,
        type:undefined,
        remark:undefined,
        mode:undefined
      },
      tableData:[],
      dateRange:[],
      page: 1,
      pageSize: 20,
      total:0,
      journal:[
        {
          value: 1,
          label: "登陆日志"
        },
        {
          value: 2,
          label: "操作日志"
        },
        {
          value: 3,
          label: "备注日志"
        }
      ],
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        model: {
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      logIndex(params).then(res=>{
        if(res.data.code == 200){
          this.tableData = res.data.data.records;
          this.tableData.map((item,index)=>{
            item.ids = index + 1;
          })
          this.total = res.data.data.total;
        }
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
  },
  mounted() {
    this.initData();
  },
  created() {

  }
};
</script>
<style scoped lang="less">
  .el-button {
    margin-left: 5px;
    border-radius: 3px;
    padding: 10px 20px;
  }
  .rotating {
    transform: rotate(90deg);
  }
  .el-button--small.icon-button-auto{
    padding: 12px 9px;
    position: relative;
    top: -1px;
  }
  .array-class{
    width: 70%;
    display: flex;
    flex-wrap:wrap;
    margin-top: 5px;
    .el-input{
      margin-right: 30px;
      width:210px;
      margin-top: 15px;
    }
    .el-select{
      margin-right: 30px;
      width:210px;
      margin-top: 15px;
    }
    .el-date-editor{
      width:450px ;
      margin-top: 15px;
      margin-right: 30px;
    }
  }
</style>


